export interface Purchase {
  name: string
  city: string
}

export const purchases: Purchase[] = [
  { name: 'Camille L.', city: 'Paris' },
  { name: 'Amandine T.', city: 'Lyon' },
  { name: 'Marion P.', city: 'Bordeaux' },
  { name: 'Céline B.', city: 'Nantes' },
  { name: 'Léa F.', city: 'Lille' },
  { name: 'Charlotte M.', city: 'Toulouse' },
  { name: 'Audrey S.', city: 'Marseille' },
  { name: 'Pauline G.', city: 'Strasbourg' },
  { name: 'Justine V.', city: 'Rennes' },
  { name: 'Mathilde D.', city: 'Montpellier' },
]
